<article class="htd" [class.htd--abierta]="abierta">
  <button type="button" class="htd__cabeza" [attr.aria-expanded]="abierta" (click)="alterna()">
    <span class="htd__flecha material-icons" aria-hidden="true">{{ abierta ? "expand_more" : "chevron_right" }}</span>
    <span class="htd__titulo">
      <span class="htd__id">{{ tarea.id }}</span>
      <span class="htd__nombre">{{ tarea.nombre }}</span>
    </span>
    <span class="htd__resumen">
      <span class="htd__peso">peso {{ tarea.peso }}</span>
      @if (tarea.obtenido?.resuelta) {
        <span class="htd__chip" data-estado="ok">Resuelta</span>
      } @else {
        <span class="htd__chip" data-estado="falla">No resuelta</span>
      }
      @if (numero(tarea.obtenido?.capacidad_media) !== null) {
        <span class="htd__cap">
          {{ tarea.obtenido?.capacidad_media | number: "1.1-1" }}
          @if (numero(tarea.obtenido?.capacidad_desv) !== null) {
            <small>± {{ tarea.obtenido?.capacidad_desv | number: "1.1-2" }}</small>
          }
        </span>
      }
      @if (numero(tarea.obtenido?.costo_usd) !== null) {
        <span class="htd__costo">$ {{ tarea.obtenido?.costo_usd | number: "1.2-2" }}</span>
      }
    </span>
  </button>

  @if (abierta) {
    <div class="htd__cuerpo">
      <div class="htd__pestanas" role="tablist">
        <button type="button" role="tab" [attr.aria-selected]="pestana === 'esperado'" [class.is-activa]="pestana === 'esperado'" (click)="elige('esperado')">Lo esperado</button>
        <button type="button" role="tab" [attr.aria-selected]="pestana === 'obtenido'" [class.is-activa]="pestana === 'obtenido'" (click)="elige('obtenido')">Lo obtenido</button>
        <button type="button" role="tab" [attr.aria-selected]="pestana === 'repeticiones'" [class.is-activa]="pestana === 'repeticiones'" (click)="elige('repeticiones')">Repeticiones ({{ ejecuciones.length }})</button>
      </div>

      @switch (pestana) {
        @case ("esperado") {
          <div class="htd__panel" role="tabpanel">
            @if (tarea.descripcion) {
              <p class="htd__descripcion">{{ tarea.descripcion }}</p>
            }
            <div class="htd__datos">
              <span><strong>Rubros evaluados:</strong>
                @for (r of rubros; track r; let ultimo = $last) {
                  {{ nombreRubro(r) }}{{ ultimo ? "" : "," }}
                }
              </span>
              @if (tarea.umbral_resuelta !== undefined && tarea.umbral_resuelta !== null) {
                <span><strong>Se da por resuelta con:</strong> {{ tarea.umbral_resuelta }}</span>
              }
            </div>
            @for (b of esperado; track $index) {
              <app-bloque-evidencia [bloque]="b"></app-bloque-evidencia>
            }
            @if (!esperado.length) {
              <p class="htd__vacio">El archivo no describe lo esperado de esta tarea.</p>
            }
          </div>
        }
        @case ("obtenido") {
          <div class="htd__panel" role="tabpanel">
            <dl class="htd__hechos">
              <div><dt>Capacidad</dt><dd>
                @if (numero(tarea.obtenido?.capacidad_media) !== null) {
                  {{ tarea.obtenido?.capacidad_media | number: "1.1-1" }}
                  @if (numero(tarea.obtenido?.capacidad_desv) !== null) { ± {{ tarea.obtenido?.capacidad_desv | number: "1.1-2" }} }
                } @else { — }
              </dd></div>
              <div><dt>Resuelta</dt><dd>{{ tarea.obtenido?.resuelta ? "Sí" : "No" }}</dd></div>
              <div><dt>Costo</dt><dd>
                @if (numero(tarea.obtenido?.costo_usd) !== null) { $ {{ tarea.obtenido?.costo_usd | number: "1.2-4" }} } @else { — }
              </dd></div>
              <div><dt>Latencia media</dt><dd>
                @if (numero(tarea.obtenido?.latencia_media_s) !== null) { {{ tarea.obtenido?.latencia_media_s | number: "1.0-1" }} s } @else { — }
              </dd></div>
              <div><dt>Repeticiones</dt><dd>{{ tarea.obtenido?.repeticiones ?? ejecuciones.length }}</dd></div>
              @if (tarea.obtenido?.fallas_infra) {
                <div><dt>Fallas de infraestructura</dt><dd>{{ tarea.obtenido?.fallas_infra }}</dd></div>
              }
            </dl>
            <table class="htd__rubros">
              <thead><tr><th scope="col">Rubro</th><th scope="col">Obtenido</th></tr></thead>
              <tbody>
                @for (r of rubrosObtenidos; track r.id) {
                  <tr>
                    <td>{{ nombreRubro(r.id) }}</td>
                    <td>@if (r.valor !== null) { {{ r.valor | number: "1.1-1" }} } @else { no aplica }</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
        @case ("repeticiones") {
          <div class="htd__panel" role="tabpanel">
            @for (e of ejecuciones; track $index) {
              <section class="htd__rep">
                <h5 class="htd__rep-titulo">
                  Repetición {{ e.repeticion + 1 }}
                  @if (e.ok) {
                    <span class="htd__chip" data-estado="ok">Válida</span>
                  } @else {
                    <span class="htd__chip" data-estado="falla">Falla de infraestructura</span>
                  }
                </h5>
                @if (e.error_infra) {
                  <p class="htd__error">{{ e.error_infra }}</p>
                }
                <dl class="htd__hechos">
                  <div><dt>Duración</dt><dd>@if (numero(e.duracion_s) !== null) { {{ e.duracion_s | number: "1.0-1" }} s } @else { — }</dd></div>
                  <div><dt>Costo</dt><dd>@if (numero(e.costo_usd) !== null) { $ {{ e.costo_usd | number: "1.2-4" }} } @else { — }</dd></div>
                  <div><dt>Turnos</dt><dd>{{ e.turnos ?? "—" }}</dd></div>
                  <div><dt>Tokens</dt><dd>{{ tokens(e) }}</dd></div>
                  <div class="htd__ancho"><dt>Entrega</dt><dd class="htd__mono">{{ e.entrega?.rama || "—" }}@if (e.entrega?.sha) { · {{ e.entrega?.sha }} }</dd></div>
                  <div class="htd__ancho"><dt>Archivos</dt><dd>{{ archivos(e) }}</dd></div>
                </dl>
                @for (p of puntajes(e); track $index) {
                  <div class="htd__puntaje">
                    <div class="htd__puntaje-cabeza">
                      <strong>{{ nombreRubro(p.rubro, p.nombre) }}</strong>
                      <span class="htd__puntaje-valor">@if (numero(p.valor) !== null) { {{ p.valor | number: "1.1-1" }} } @else { no aplica }</span>
                      @if (p.metodo) {
                        <span class="htd__metodo">{{ p.metodo }}</span>
                      }
                    </div>
                    @if (notas(p).length) {
                      <ul class="htd__notas">
                        @for (n of notas(p); track $index) {
                          <li>{{ n }}</li>
                        }
                      </ul>
                    }
                    @for (b of evidencia(p); track $index) {
                      <app-bloque-evidencia [bloque]="b"></app-bloque-evidencia>
                    }
                  </div>
                }
              </section>
            }
            @if (!ejecuciones.length) {
              <p class="htd__vacio">El archivo no trae repeticiones de esta tarea.</p>
            }
          </div>
        }
      }
    </div>
  }
</article>
